import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import ViewBank from './pages/ViewBank';
import SponsorForm from './pages/SponsorForm';
import BookCollection from './pages/BookCollection';
import Account from './pages/Account';
import BehindBars from './pages/BehindBars';
import NearestBanks from './pages/NearestBanks';
import GeoQueryTest from './pages/GeoQueryTest';
import ThankYouSponsor from './pages/ThankYouSponsor';
import Campaign from './pages/ts-cs/Campaign';
import SingleTile from './pages/ts-cs/SingleTile';
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import frlogo from './assets/images/fr_logo_no_edge.svg';
import BankSearch from './pages/BankSearch';
import TestPage from './pages/TestPage';
import CampaignInvitation from './pages/CampaignInvitation';
import NewProfile from './pages/NewProfile';
import ImageUpload from './pages/ImageUpload';
import Dashboard from './pages/Dashboard';
import { CookiesProvider, useCookies } from 'react-cookie'; 

const App = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['fr-share-done'])

  return (
    <>
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<ViewBank />} />
          <Route path="/login" element={ <Login /> } />
          <Route path="/account" element={ <Account /> } />
          <Route path="/geo-test" element={ <SponsorForm /> } />
          <Route path="/bank" element={ <ViewBank /> } /> 
          <Route path="/new-profile" element={ <NewProfile /> } /> 
          <Route path="/book-collection" element={ <BookCollection /> } />
          <Route path="/bank-behind-bars" element={ <BehindBars /> } />
          <Route path="/nearest" element={ <NearestBanks /> } />
          <Route path="/sponsor" element={ <SponsorForm /> } />
          <Route path="/campaign" element={ <CampaignInvitation /> } />
          <Route path="/sponsor-campaign" element={ <GeoQueryTest /> } />
          <Route path="/sponsor/thank-you" element={ <ThankYouSponsor /> } />
          <Route path="/sponsor-tc-single" element={ <SingleTile /> } />
          <Route path="/sponsor-tc-campaign" element={ <Campaign /> } />
          <Route path="/image-upload" element={ <ImageUpload /> } />
          <Route path="/search" element={ <BankSearch /> } />
          <Route path="/dashboard" element={ <Dashboard /> } />
          <Route path="/test" element={ <TestPage /> } />
        </Routes>
    </BrowserRouter>
    <FloatingWhatsApp phoneNumber='447453958291' accountName='Fundraise & Recycle' avatar={frlogo} />
    </>
  );
}

export default App;